// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file Type definition for linked node.
 * @author James Reid
 */

// @ts-check

// @@imports-utils
/* eslint-disable no-unused-vars -- Type imports. */
import { DoubleLinkedList, DoubleLinkedListNode } from "../utils/data/index.js"
/* eslint-enable no-unused-vars -- Close disable-enable pair. */

// @@body
/* eslint-disable jsdoc/sort-tags -- Template tag order required for generic. */
/**
 * Double linked list node type declaration with `previous` and `next` node
 * properties set (i.e. not expected to be null).
 * @template NodeType
 * @typedef {object} DoubleLinkedNode
 * @property {NodeType} value Value of node.
 * @property {DoubleLinkedList.<NodeType>} list Node linked list container.
 * @property {DoubleLinkedListNode.<NodeType>} previous Previous node.
 * @property {DoubleLinkedListNode.<NodeType>} next Next node.
 */
/* eslint-enable jsdoc/sort-tags -- Close disable-enable pair. */

/* eslint-disable jsdoc/sort-tags -- Template tag order required for generic. */
/**
 * Double linked list node type declaration with `previous` and `next` node
 * properties of current node and *all* child or parent nodes set (i.e. not
 * expected to be null).
 * @template NodeType
 * @typedef {object} NestedDoubleLinkedNode
 * @property {NodeType} value Value of node.
 * @property {DoubleLinkedList.<NodeType>} list Node linked list container.
 * @property {NestedDoubleLinkedNode.<NodeType>} previous Previous node.
 * @property {NestedDoubleLinkedNode.<NodeType>} next Next node.
 */
/* eslint-enable jsdoc/sort-tags -- Close disable-enable pair. */

// @@exports
/**
 * @template NodeType
 * @type {DoubleLinkedNode.<NodeType>}
 * @ignore
 */
export let DoubleLinkedNode

/**
 * @template NodeType
 * @type {NestedDoubleLinkedNode.<NodeType>}
 * @ignore
 */
export let NestedDoubleLinkedNode
